import React, { useState, useCallback, useEffect } from "react";
import * as R from "ramda";
import { Slider, Button, InputNumber } from "antd";

import * as gtag from "../../../../../lib/gtag";

import { Title, Container } from "./FilterComponents";

import styled from "styled-components/macro";

const SliderContainer = styled.div`
  width: 100%;

  .ant-slider {
    margin-top: 2px;
  }
  &
    .ant-slider:not(.ant-slider-disabled)
    > .ant-slider-step
    > .ant-slider-dot:not([aria-disabled="true"]) {
    border-color: ${({ theme }) => theme["@gray-40"]} !important;
  }
  * .ant-slider-handle:not([aria-disabled="true"]),
  &
    .ant-slider:not(.ant-slider-disabled)
    > .ant-slider-step
    > .ant-slider-dot.ant-slider-dot-active:not([aria-disabled="true"]) {
    border-color: ${({ theme }) => theme["@primary"]} !important;
  }
  * .ant-slider-rail:not([aria-disabled="true"]) {
    background-color: ${({ theme }) => theme["@gray-40"]} !important;
  }
  * .ant-slider-track {
    background-color: ${({ theme }) => theme["@primary"]} !important;
  }
  * .ant-slider-handle {
    transform: none !important;
  }
  * .ant-slider-mark-text {
    font-size: 11px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

function RangeFilters({
  loading,
  onChange,
  value,
  min = 0,
  max = 100,
  title,
  disabled,
  filterName = "range",
  marks,
  load = R.identity,
  store = R.identity
}) {
  const [internalValue, setInternalValue] = useState(load(value));

  const handleChange = useCallback(() => onChange(store(internalValue)), [
    internalValue,
    onChange,
    store
  ]);

  useEffect(() => setInternalValue(load(value)), [load, value]);

  return (
    <details
      data-test={`filter-${filterName}`}
      open={value && !R.isEmpty(value) && !R.equals(load(value), [min, max])}
    >
      <Title>
        <h4>{title}</h4>
      </Title>
      <Container>
        <SliderContainer>
          <Slider
            range
            min={min}
            max={max}
            marks={marks}
            value={internalValue}
            disabled={loading || disabled}
            onChange={setInternalValue}
          />
          <Wrapper>
            <InputNumber
              data-test={`input-${filterName}-min`}
              style={{ width: 80 }}
              disabled={disabled}
              value={internalValue[0]}
              min={min}
              max={max}
              onChange={val => {
                setInternalValue(prevState => [val, prevState[1]]);
              }}
            />
            <span className="div">-</span>
            <InputNumber
              data-test={`input-${filterName}-max`}
              style={{ width: 80 }}
              disabled={disabled}
              value={internalValue[1]}
              min={min}
              max={max}
              onChange={val => {
                setInternalValue(prevState => [prevState[0], val]);
              }}
            />
            <Button
              data-test={`button-${filterName}-filter`}
              className="clear"
              shape="circle"
              icon="arrow-right"
              type="primary"
              disabled={
                disabled || loading || R.equals(load(value), internalValue)
              }
              onClick={e => {
                gtag.event({
                  category: "VacancyCandidates",
                  action: `filter${filterName}`
                });
                handleChange(e);
              }}
            />
          </Wrapper>
        </SliderContainer>
      </Container>
    </details>
  );
}

export default RangeFilters;
